import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { URLS } from '../../resources/constants';
import { getAccountSettings, getThirdPartyStepsCompleted } from '../../store/settings/selectors';
import { getBranch } from '../../store/user/selectors';

const QboImportRoutes = () => {
    const branch = useSelector(getBranch);
    const accountSettings = useSelector(getAccountSettings);
    const stepsCompleted = useSelector(getThirdPartyStepsCompleted);
    const settingsMatchBranch = Number(accountSettings.location_branch_id) === Number(branch?.id);

    return settingsMatchBranch && stepsCompleted >= 5 ? <Navigate to={URLS.DASHBOARD} replace /> : <Outlet />;
};

export default QboImportRoutes;
